import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Import Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
    /* Hide scrollbar for Firefox */
    scrollbar-width: none;
    /* Hide scrollbar for IE/Edge */
    -ms-overflow-style: none;
  }

  body {
    background-color: ${({ theme }) => theme.colors.bgLight};
    color: ${({ theme }) => theme.colors.textDark};
    font-family: ${({ theme, isArabic }) => (isArabic ? theme.fonts.arabic : theme.fonts.english)};
    direction: ${({ isArabic }) => (isArabic ? 'rtl' : 'ltr')};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: 1.2;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.textDark};
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: ${({ theme }) => theme.transitions.default};
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
    transition: ${({ theme }) => theme.transitions.default};
  }

  input, select, textarea {
    font-family: inherit;
  }

  /* Hide Scrollbar for Webkit Browsers (Chrome, Safari, Opera) */
  ::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;